module.exports = __webpack_public_path__ + "media/application/images/header-arrow-black-d34516cc05c9a38eeb629461d575f887.svg";